export const isIOS14OrBelow = () => {
  if (typeof window === 'undefined') return;
  const ua = window.navigator.userAgent;
  const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
  if (!iOS) return false;
  const version = ua.match(/OS (\d+)_/i);
  return version && parseInt(version[1], 10) <= 14;
};
